import { render, staticRenderFns } from "./SingleVendor.vue?vue&type=template&id=4420c527&"
import script from "./SingleVendor.vue?vue&type=script&lang=js&"
export * from "./SingleVendor.vue?vue&type=script&lang=js&"
import style0 from "./SingleVendor.vue?vue&type=style&index=0&id=4420c527&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports